export default {
    'years': {
        'en': 'years',
        'fr': 'années'
    },
    'login_title': {
        'en': 'Authentication',
        'fr': 'Authentification'
    },
    'login_email': {
        'en': 'Email',
        'fr': 'Email'
    },
    'login_password': {
        'en': 'Password',
        'fr': 'Mot de passe'
    },
    'login_button': {
        'en': 'Login',
        'fr': 'Se connecter'
    },
    'login_error': {
        'en': 'Please specify all the fields. ',
        'fr': 'Veuillez spécifier tous les champs. '
    },
    'login_error_mail': {
        'en': '(The email is not correct)',
        'fr': '(L\'adresse email est incorrecte)'
    },
    'login_error_password': {
        'en': '(The password is not correct)',
        'fr': '(Le mot de passe n\'est pas renseigné)'
    },
    'login_error_info': {
        'en': 'The authentication details are incorrect.',
        'fr': 'Les informations d\'authentification fournie sont incorrectes.'
    },
    'login_error_server': {
        'en': 'No response from server.',
        'fr': 'Le serveur ne répond pas.'
    },
    'login_login_panel': {
        'en': 'Login',
        'fr': 'Connexion'
    },
    'login_reset_password_panel': {
        'en': 'Forgot password',
        'fr': 'Mot de passe oublié'
    },
    'login_password_reset_button': {
        'en': 'Submit',
        'fr': 'Valider'
    },
    'login_password_reset_success': {
        'en': 'An email was sent to this address to reset your password',
        'fr': 'Un email a été envoyé à cette adresse pour réinitialiser son mot de passe'
    },
    'login_password_reset_failed': {
        'en': 'No email could be sent to this address',
        'fr': 'Aucun email n\'a pu être envoyé à cette adresse'
    },
    // Header Nav
    'home': {
        'en': 'Home',
        'fr': 'Accueil'
    },
    'my_sites': {
        'en': 'My audits',
        'fr': 'Mes audits'
    },
    'my_simulations': {
        'en': 'My simulations',
        'fr': 'Mes simulations'
    },
    'history_title': {
        'en': 'My history',
        'fr': 'Mon historique'
    },
    'simulations_total': {
        'en': 'Total simulations',
        'fr': 'Total des simulations'
    },
    'simulations_repetition': {
        'en': 'Breakdown of simulations by month',
        'fr': 'Répartition des simulations par mois'
    },
    'no_simulation': {
        'en': 'No simulation',
        'fr': 'Aucune simulation'
    },
    'history_modal_title': {
        'en': 'History of my simulations',
        'fr': 'Historique de mes simulations'
    },
    'log_out': {
        'en': 'Log out',
        'fr': 'Déconnexion'
    },
    'form_reset_password_empty_password_error': {
        'en': 'The password is empty',
        'fr': 'Le mot de passe est vide'
    },
    'form_reset_password_empty_password_confirmation_error': {
        'en': 'The confirmation password is empty',
        'fr': 'Le mot de passe de confirmation est vide'
    },
    'form_reset_password_empty_password_too_short_error': {
        'en': 'The password must contain at least 8 characters',
        'fr': 'Le mot de passe doit contenir au moins 8 caractères'
    },
    'form_reset_password_and_confirmation_password_no_match': {
        'en': 'Passwords don\'t match',
        'fr': 'Les mots de passe ne sont pas identiques'
    },
    'form_reset_password_success': {
        'en': 'Password updated',
        'fr': 'Le mot de passe a été modifié'
    },
    'form_reset_password_fail': {
        'en': 'Cannot change password',
        'fr': 'Le mot de passe n\'a pas pu être modifié'
    },
    'form_reset_password_validation_error_title': {
        'en': 'Validation error',
        'fr': 'Erreur de validation'
    },
    'form_reset_password_validation_error_message': {
        'en': 'Please correct the form',
        'fr': 'Corrigez le formulaire s\'il vous plait'
    },
    'menu_form_reset_password': {
        'en': 'Reset password',
        'fr': 'Changer le mot de passe'
    },
    'form_reset_password_title': {
        'en': 'Reset password',
        'fr': 'Changer le mot de passe'
    },
    'form_reset_password_placeholder_password': {
        'en': 'New Password',
        'fr': 'Nouveau mot de passe'
    },
    'form_reset_password_placeholder_confirmation': {
        'en': 'Confirm password',
        'fr': 'Confirmer le mot de passe'
    },
    // Homepage
    'home_title': {
        'en': 'energy optimization application of motorized systems',
        'fr': 'application d\'optimisation énergétique des systèmes motorisés'
    },
    'home_button': {
        'en': 'start',
        'fr': 'commencer'
    },
    'home_list_object_title': [
        {
            'en': 'simple<br/>tool',
            'fr': 'outil<br/>simple'
        },
        {
            'en': 'efficient<br/>tool',
            'fr': 'outil<br/>performant'
        },
        {
            'en': 'simplified<br/>reports',
            'fr': 'rapport<br/>simplifiés'
        }
    ],
    'home_list_object_description': [
        {
            'en': 'For a quick energy audit of electric motors.',
            'fr': 'Pour un audit énergétique rapide des moteurs électriques.'
        },
        {
            'en': 'Automated calculations of current consumption, valuation of gains and investments.',
            'fr': 'Calculs automatisés des consommations actuelles, évaluation des gains et investissements.'
        },
        {
            'en': 'Automated synthetic report.',
            'fr': 'Rapport synthétique automatisé.'
        }
    ],
    'home_youtube_title': {
        'en': 'a complicated computation in a few clicks',
        'fr': 'un calcul complexe en quelques clics'
    },
    'home_youtube_description': {
        'en': 'Discover the Motorbox solution for your motors energy audits.',
        'fr': 'Découvrez la solution Motorbox pour vos audits énergétiques de moteurs.'
    },
    // Footer
    'viveco_description': {
        'en': 'Economic and ecological performance simulator for motor replacement.',
        'fr': 'Simulateur de performance économique et écologique de remplacement de moteur.'
    },
    'help_link': {
        'en': 'help',
        'fr': 'aide'
    },
    'contact_link': {
        'en': 'contact',
        'fr': 'contact'
    },
    'mentions_link': {
        'en': 'legal mentions',
        'fr': 'mentions légales'
    },
    'copyright': {
        'en': '© 2017 EDF All rights reserved.',
        'fr': '© 2017 EDF Tous droits réservé.'
    },
    // sites page
    'sites_archiving_title': {
        'en': 'Audit deleting',
        'fr': 'Supprimer un audit'
    },
    'sites_archiving_desc': {
        'en': 'Do you wish to delete this audit ?',
        'fr': 'Souhaitez vous supprimer cet audit ?'
    },
    'sites_title': {
        'en': 'Audits',
        'fr': 'Audits'
    },
    'sites_add_button': {
        'en': 'add an audit',
        'fr': 'ajouter un audit'
    },
    'sites_search_bar': {
        'en': 'look for an audit',
        'fr': 'chercher un audit'
    },
    'sites_choose_button': {
        'en': 'choose',
        'fr': 'sélectionner'
    },
    'sites_tab_name': {
        'en': 'Name',
        'fr': 'Nom'
    },
    'sites_tab_comment': {
        'en': 'Comment',
        'fr': 'Commentaire'
    },
    'sites_tab_update': {
        'en': 'Update',
        'fr': 'Modifier'
    },
    'sites_tab_archive': {
        'en': 'Delete',
        'fr': 'Supprimer'
    },
    'sites_tab_choose': {
        'en': 'Choose',
        'fr': 'Sélectionner'
    },
    //site page
    'site_default_title': {
        'en': 'New audit',
        'fr': 'Nouvel audit'
    },
    'site_default_update_title': {
        'en': 'Update an audit',
        'fr': 'Modifier un audit'
    },
    'site_form_category_audit': {
        'en': 'Audit Informations',
        'fr': 'Informations Audit'
    },
    'site_form_category_site': {
        'en': 'Site Informations',
        'fr': 'Informations Site'
    },
    'site_form_category_energy': {
        'en': 'Energy Informations',
        'fr': 'Informations Energie'
    },
    'site_form_category_contacts': {
        'en': 'Contacts',
        'fr': 'Contacts'
    },
    'site_form_category_picture': {
        'en': 'Picture',
        'fr': 'Image'
    },
    'site_form_picture_error': {
        'en': 'Picture has the wrong size. It must be over 1000x750',
        'fr': 'La taille de l\'image n\'est pas bonne. Elle doit être supérieure à 1000x750'
    },
    'site_form_category_misc': {
        'en': 'Details',
        'fr': 'Remarques / Notes'
    },
    'site_form_audit': {
        'en': 'Audit name',
        'fr': 'Nom d\'un audit'
    },
    'site_form_name': {
        'en': 'Site name',
        'fr': 'Nom du site'
    },
    'site_form_picture': {
        'en': 'Site image',
        'fr': 'Image du site'
    },
    'site_form_yearly_consumption': {
        'en': 'Yearly consumption in GWh/year',
        'fr': 'Consommation annuelle en GWh/an'
    },
    'site_form_cee_price': {
        'en': 'CEE subvention in €/MWh cumac',
        'fr': 'Subvention CEE en €/MWh cumac'
    },
    'site_form_cee_price_error_message': {
        'en': 'The EDF\'s CEE prices is required',
        'fr': 'Le prix des CEE d\'EDF est obligatoire'
    },
    'site_form_operational_mod': {
        'en': 'Operational mod',
        'fr': 'Mode de fonctionnement'
    },
    'site_form_name_error_message': {
        'en': 'The site name is required',
        'fr': 'Le nom du site est requis'
    },
    'site_form_audit_error_message': {
        'en': 'The audit name is required',
        'fr': 'Le nom d\'un audit est requis'
    },
    'site_form_naf_code': {
        'en': 'NAF code',
        'fr': 'Code NAF'
    },
    'site_form_start': {
        'en': 'Audit start',
        'fr': 'Début de l\'audit'
    },
    'site_form_end': {
        'en': 'Audit end',
        'fr': 'Fin de l\'audit'
    },
    'site_form_start_placeholder': {
        'en': 'Select date',
        'fr': 'Sélectionner une date'
    },
    'site_form_end_placeholder': {
        'en': 'Select date',
        'fr': 'Sélectionner une date'
    },
    'site_form_naf_code_error_message': {
        'en': 'The code NAF is required',
        'fr': 'Le code NAF d\'un audit est requis'
    },
    'site_form_operational_mod_error_message': {
        'en': 'The operational mod is required',
        'fr': 'Le mode de fonctionnement est requis'
    },
    'site_form_start_error_message': {
        'en': 'The start date of the audit is required',
        'fr': 'La date de début d\'un audit est requise'
    },
    'site_form_end_error_message': {
        'en': 'The end of the audit is required',
        'fr': 'La date de fin d\'un audit est requise'
    },
    'site_form_comment': {
        'en': 'Comment',
        'fr': 'Commentaire'
    },
    'site_form_price': {
        'en': 'Electricity price (€/MWh)',
        'fr': 'Prix de l\'électricité (€/MWh)'
    },
    'site_form_price_error_message': {
        'en': 'The price is required',
        'fr': 'Le prix est requis'
    },
    'site_form_location': {
        'en': 'Location',
        'fr': 'Adresse'
    },
    'site_form_edf_delegate_1': {
        'en': 'EDF delegate 1 (optional)',
        'fr': 'Interlocuteur EDF n°1 (optionel)'
    },
    'site_form_edf_delegate_2': {
        'en': 'EDF delegate 2 (optional)',
        'fr': 'Interlocuteur EDF n°2 (optionel)'
    },
    'site_form_edf_delegate_name_label': {
        'en': 'Name',
        'fr': 'Nom'
    },
    'site_form_edf_delegate_job_label': {
        'en': 'Job',
        'fr': 'Métier'
    },
    'site_form_edf_delegate_phone_label': {
        'en': 'Phone',
        'fr': 'Téléphone'
    },
    'site_form_edf_delegate_mail_label': {
        'en': 'Mail',
        'fr': 'Email'
    },
    'site_form_location_error_message': {
        'en': 'The location is required',
        'fr': 'L\'adresse est requise'
    },
    'site_form_contact': {
        'en': 'Client contact',
        'fr': 'Contact client'
    },
    'site_form_contact_error_message': {
        'en': 'The contact\'s name is required',
        'fr': 'Le nom du contact est requis'
    },
    'site_form_client_name': {
        'en': 'Company',
        'fr': 'Société'
    },
    'site_form_client_name_error_message': {
        'en': 'The client name is required',
        'fr': 'Le nom du client est requis'
    },
    'site_dialog_title': {
        'en': 'Confirm',
        'fr': 'Confirmation'
    },
    'site_dialog_text': {
        'en': 'Do you really want to delete this audit ', // for both language, site's name + ' ?'
        'fr': 'Confirmez-vous la suppression de l\'audit '//    are added after this
    },
    // motors page
    'motors_audit_report_title': {
        'en': 'Reports',
        'fr': 'Rapports'
    },
    'motors_audit_report_button_disabled': {
        'en': 'There is no report available for this model, please create one',
        'fr': 'Aucun rapport associé à ce modèle n\'existe, veuillez en créer un'
    },
    'motors_audit_report_config_button': {
        'en': 'Generate the report',
        'fr': 'Générer le rapport'
    },
    'motors_audit_report_config_button_modify': {
        'en': 'Modify the report',
        'fr': 'Modifier le rapport'
    },
    'motors_audit_report_simulations_retrieval_error': {
        'en': 'Error while retrieving simulations data',
        'fr': 'Les simulations pour le rapport n\'ont pas pu être récupérées'
    },
    'motors_archiving_title': {
        'en': 'Motor deleting',
        'fr': 'Supprimer un moteur'
    },
    'motors_archiving_desc': {
        'en': 'Do you wish to delete this motor ?',
        'fr': 'Souhaitez vous supprimer ce moteur ?'
    },
    'motors_add_button': {
        'en': 'add a motor',
        'fr': 'ajouter un moteur'
    },
    'motors_import_button': {
        'en': 'import a motor',
        'fr': 'importer un moteur'
    },
    'motors_import_modal_title': {
        'en': 'IMPORT A MOTOR',
        'fr': 'IMPORTER UN MOTEUR'
    },
    'motors_search_bar': {
        'en': 'look for a motor',
        'fr': 'chercher un moteur'
    },
    'motors_select': {
        'en': 'select this motor',
        'fr': 'sélectionner ce moteur'
    },
    'motors_simulation_button': {
        'en': 'launch a simulation',
        'fr': 'lancer une simulation'
    },
    'motors_tab_name': {
        'en': 'Name',
        'fr': 'Nom'
    },
    'motors_tab_comment': {
        'en': 'Comment',
        'fr': 'Commentaire'
    },
    'motors_tab_update': {
        'en': 'Update',
        'fr': 'Modifier'
    },
    'motors_tab_archive': {
        'en': 'Delete',
        'fr': 'Supprimer'
    },
    'motors_tab_choose': {
        'en': 'Choose',
        'fr': 'Sélectionner'
    },
    // Audit's report configuration page
    'audit_report_configuration_title': {
        'en': 'Report',
        'fr': 'Rapport'
    },
    'audit_report_configuration_choose_engine_button': {
        'en': 'Configure report',
        'fr': 'Configurer le rapport'
    },
    'audit_report_override_values_button': {
        'en': 'Override solutions results',
        'fr': 'Éditer les résultats des solutions'
    },
    'audit_report_configuration_save': {
        'en': 'Save modifications',
        'fr': 'Sauvegarder les modifications'
    },
    'audit_report_download': {
        'en': 'Generate and download report',
        'fr': 'Générer et télécharger le rapport'
    },
    'audit_report_download_button': {
        'en': 'Download report',
        'fr': 'Télécharger le rapport'
    },
    'audit_report_general_error_message_prefix': {
        'en': 'Error while generating report : ',
        'fr': 'Erreur lors de la génération du rapport : '
    },
    'audit_report_save_before_download': {
        'en': 'Save your report before downloading it',
        'fr': 'Sauvegarder votre rapport avant de le télécharger'
    },
    'audit_report_generation_error_message': {
        'en': 'Error encountered when preparing report, please try again',
        'fr': 'Erreur rencontrée lors de la préparation du rapport, veuillez réessayer'
    },
    'audit_report_generation_waiting_message': {
        'en': 'Default report is being prepared, please wait',
        'fr': 'Veuillez patienter durant la préparation du rapport'
    },
    'audit_report_config_modal_title': {
        'en': 'Configuration of the report',
        'fr': 'Configuration du rapport à générer'
    },
    'audit_report_override_modal_title': {
        'en': 'Override solutions results',
        'fr': 'Éditer les résultats des solutions'
    },
    'audit_report_override_modal_initial_value_label': {
        'en': 'Initial value:',
        'fr': 'Valeur initiale:'
    },
    'audit_report_config_max_gain_label': {
        'en': 'Security coefficient',
        'fr': 'Coefficient de sécurité'
    },
    'audit_report_config_max_gain_description': {
        'en': 'Reduction in % applied on gains computed by the software',
        'fr': 'Réduction en % appliquée sur les gains calculés par le logiciel'
    },
    'audit_report_config_max_gain_override_values_description': {
        'en': 'The solutions with overridden values won\'t take this reduction in account',
        'fr': 'Les solutions comportant des valeurs surchargées ne seront pas affectées par cette réduction'
    },
    'audit_report_config_max_gain_error_message': {
        'en': 'Maximum gain must be between 0 and 100 %',
        'fr': 'Les gains maximaux à afficher doivent être compris entre 0 et 100 %'
    },
    'audit_report_config_modal_model_type_label': {
        'en': 'Report type',
        'fr': 'Type de rapport'
    },
    'audit_report_config_modal_engines_select_label': {
        'en': 'Select the solutions for the report',
        'fr': 'Sélectionner les solutions à afficher dans le rapport'
    },
    'audit_report_config_modal_engines_table_name': {
        'en': 'Motor',
        'fr': 'Moteurs'
    },
    'audit_report_config_modal_engines_table_solution': {
        'en': 'Solutions',
        'fr': 'Solutions'
    },
    'audit_report_config_modal_engines_table_gain_energy': {
        'en': 'MWh gains',
        'fr': 'Gains MWh'
    },
    'audit_report_config_modal_engines_table_gain_money': {
        'en': 'Money gain (€)',
        'fr': 'Gains €'
    },
    'audit_report_config_modal_engines_table_raw_invest': {
        'en': 'Raw investment',
        'fr': 'Investissement Brut €'
    },
    'audit_report_config_modal_engines_table_overall_invest': {
        'en': 'Overall investment €',
        'fr': 'Investissement global €'
    },
    'audit_report_config_modal_engines_table_tri': {
        'en': 'Final ROI',
        'fr': 'TRI final'
    },
    'audit_report_config_modal_engines_table_rang': {
        'en': 'Rank',
        'fr': 'Rang'
    },
    'audit_report_config_modal_engines_table_select': {
        'en': 'Select',
        'fr': 'Sélectionner'
    },
    'audit_report_config_modal_engines_no_data': {
        'en': 'No simulation available, please create one',
        'fr': 'Aucune simulation de disponible, veuillez en créer une'
    },
    'audit_report_config_modal_return_button': {
        'en': 'Back to my audit',
        'fr': 'Retourner à mon audit'
    },
    'audit_report_config_modal_override_button': {
        'en': 'Override solutions values',
        'fr': 'Surcharger les valeurs des solutions'
    },
    'audit_report_config_modal_override_button_tooltip': {
        'en': 'To override the solutions values, it is mandatory to generate the report',
        'fr': 'Pour pouvoir surcharger les valeurs des solutions, il est nécessaire de générer le rapport une première fois'
    },
    'audit_report_config_modal_validate_button': {
        'en': 'Validate the configuration',
        'fr': 'Valider la configuration'
    },
    'audit_report_override_modal_validate_button': {
        'en': 'Validate the new values',
        'fr': 'Valider les nouvelles valeurs'
    },
    'audit_report_error_ranking_engines': {
        'en': 'Motors ranks must be unique and higher than 0',
        'fr': 'Les rangs des moteurs sélectionnés doivent être unique et supérieur à 0'
    },
    'audit_report_warning_confirm_text': {
        'en': 'Carefull, the audit report configuration update will erase the current modifications done on this report (expert comment, pages added, etc.)',
        'fr': 'Attention, la modification de la configuration du rapport effacera les modifications apportées à ce rapport (note de l\'expert, ajout de pages, etc.)'
    },
    'audit_report_value_override_warning_confirm_text': {
        'en': 'Carefull, the edition of the report\'s solutions values will erase the current modifications done on this report (expert comment, pages added, etc.)',
        'fr': 'Attention, la modification des résultats des solutions effacera les modifications apportées à ce rapport (note de l\'expert, ajout de pages, etc.)'
    },
    'audit_report_save_success': {
        'en': 'Report has been correctly saved',
        'fr': 'Le rapport a bien été sauvegardé'
    },
    'audit_report_save_error': {
        'en': 'Report couldn\'t be saved',
        'fr': 'Erreur lors de la sauvegarde du rapport'
    },
    'audit_report_warning_confirm_title': {
        'en': 'Confirm',
        'fr': 'Confirmation'
    },
    'audit_report_warning_confirm_validate_button': {
        'en': 'Confirm',
        'fr': 'Confirmer'
    },
    'audit_report_warning_confirm_cancel_button': {
        'en': 'Cancel',
        'fr': 'Annuler'
    },
    'audit_report_solutions_ranks_button': {
        'en': 'Set ranks',
        'fr': 'Numéroter le rang'
    },
    'audit_report_solutions_ranks_button_info': {
        'en': 'Number the selected solutions by their current order.',
        'fr': 'Numérote les solutions sélectionnées selon l\'ordre d\'affichage actuel.'
    },
    'audit_no_importable_motors_by_site': {
        'en': 'No importable engines for the site',
        'fr': 'Aucun moteur importable pour le site'
    },
    'audit_sites_no_importable_motor': {
        'en': 'No importable engines',
        'fr': 'Aucun moteur importable'
    },
    'audit_sites_select': {
        'en': 'Select a site',
        'fr': 'Sélectionnez un site'
    },
    // motor page
    'motor_default_title': {
        'en': 'New motor',
        'fr': 'Nouveau moteur'
    },
    'motor_nav': [
        {
            'en': 'Motor tray',
            'fr': 'Plaque moteur'
        },
        {
            'en': 'Application type',
            'fr': 'Type d\'application'
        },
        {
            'en': 'Regulation type',
            'fr': 'Type de régulation'
        },
        {
            'en': 'Trained machine',
            'fr': 'Machine entrainée'
        },
        {
            'en': 'Exploitation data',
            'fr': 'Données d\'exploitation'
        }
    ],
    'motor_form_name': {
        'en': 'Motor name',
        'fr': 'Nom du moteur'
    },
    'motor_form_name_error_message': {
        'en': 'The motor name is required',
        'fr': 'Le nom du moteur est requis'
    },
    'motor_form_description': {
        'en': 'Description',
        'fr': 'Description'
    },
    'motor_form_nominal_power': {
        'en': 'Nominal power (kW)',
        'fr': 'Puissance nominale (kW)'
    },
    'motor_form_nominal_power_error_message': {
        'en': 'the value must be between 1 and 9999 kW',
        'fr': 'la valeur doit être comprise entre 1 et 9999 kW'
    },
    'motor_form_nominal_power_tooltip_message': {
        'en': 'It must be between 1 and 9999 kW',
        'fr': 'Doit être comprise entre 1 et 9999 kW'
    },
    'motor_form_nominal_voltage': {
        'en': 'Nominal voltage (V)',
        'fr': 'Tension nominale (V)'
    },
    'motor_form_nominal_voltage_error_message': {
        'en': 'the value must be between 380 and 400 V',
        'fr': 'la valeur doit être comprise entre 380 et 400 V'
    },
    'motor_form_nominal_voltage_tooltip_message': {
        'en': 'It must be between 380 and 400 V',
        'fr': 'Doit être comprise entre 380 et 400 V'
    },
    'motor_form_nominal_current': {
        'en': 'Nominal intensity (A)',
        'fr': 'Courant nominal (A)'
    },
    'motor_form_nominal_current_error_message': {
        'en': 'the value must be between 3 and 2000 A',
        'fr': 'la valeur doit être comprise entre 3 et 2000 A'
    },
    'motor_form_nominal_current_tooltip_message': {
        'en': 'It must be between 3 and 2000 A',
        'fr': 'Doit être comprise entre 3 et 2000 A'
    },
    'motor_form_cos_phi': {
        'en': 'Cos Phi',
        'fr': 'Cos Phi'
    },
    'motor_form_cos_phi_error_message': {
        'en': 'the value must be between 0.6 and 0.95',
        'fr': 'la valeur doit être comprise entre 0,6 et 0,95'
    },
    'motor_form_cos_phi_tooltip_message': {
        'en': 'It must be between 0.6 and 0.95',
        'fr': 'Doit être comprise entre 0.6 et 0.95'
    },
    'motor_form_nominal_speed': {
        'en': 'Nominal speed (tr/min)',
        'fr': 'Vitesse nominale (tr/min)'
    },
    'motor_form_nominal_speed_error_message': {
        'en': 'the value must be between 1400 and 1500 tr/min, 2900 and 2999 tr/min',
        'fr': 'la valeur doit être comprise entre 1400 et 1500 tr/min, 2900 et 2999 tr/min'
    },
    'motor_form_nominal_speed_tooltip_message': {
        'en': 'It must be between 1400 and 1500 tr/min, 2900 and 2999 tr/min',
        'fr': 'Plage de vitesses supportées : 1 400 - 1 500 tr/min et 2 900 - 2 999 tr/min'
    },
    'motor_form_casing_placeholder': {
        'en': 'Choose a casing type',
        'fr': 'Choisissez un type de structure'
    },
    'motor_form_name_structure_type': {
        'en': 'Casing type',
        'fr': 'Type de structure'
    },
    'motor_form_name_structure_type_error_message': {
        'en': 'the casing type is required',
        'fr': 'le type de structure est requis'
    },
    'motor_form_name_application_type': {
        'en': 'application type',
        'fr': 'Type de application'
    },
    'motor_form_name_application_type_error_message': {
        'en': 'the application type is required',
        'fr': 'le type d\'application est requis'
    },
    'motor_form_regulation_type_error_message': {
        'en': 'the regulation type is required',
        'fr': 'le type de régulation est requis'
    },
    'motor_form_regulation_type_image_not_available': {
        'en': 'The image isn\'t available',
        'fr': 'L\'image n\'est pas disponible'
    },
    'motor_form_regulation_type_no_settings': {
        'en': 'the regulation type is required',
        'fr': 'le type de régulation est requis'
    },
    'motor_form_switch_inactive': {
        'en': 'Power',
        'fr': 'Puissance'
    },
    'motor_form_switch_active': {
        'en': 'Pressure, Output, Efficiency',
        'fr': 'Pression, Débit, Rendement'
    },
    'motor_form_machine_choice': {
        'en': 'Choose the type of data that you want to enter',
        'fr': 'Choisissez le type de donnée(s) que vous souhaitez rentrer'
    },
    'motor_form_machine_power': {
        'en': 'Power (kW)',
        'fr': 'Puissance (kW)'
    },
    'motor_form_machine_power_error_message': {
        'en': 'The machine\'s power is required',
        'fr': 'La puissance de la machine est requise'
    },
    'motor_form_machine_pressure': {
        'en': 'Pressure',
        'fr': 'Pression'
    },
    'motor_form_machine_pressure_error_message': {
        'en': 'The machine\'s pressure is required',
        'fr': 'La pression de la machine est requise'
    },
    'motor_form_machine_output': {
        'en': 'Output',
        'fr': 'Débit'
    },
    'motor_form_machine_output_error_message': {
        'en': 'The machine\'s output is required',
        'fr': 'Le débit de la machine est requis'
    },
    'motor_form_machine_pressure_unit_placeholder': {
        'en': 'Select a unit',
        'fr': 'Sélectionner une unité'
    },
    'motor_form_machine_pressure_unit': {
        'en': 'Pressure unit',
        'fr': 'Unité de pression'
    },
    'motor_form_machine_pressure_unit_error_message': {
        'en': 'Select a pressure unit',
        'fr': 'Sélectionner une unité de pression'
    },
    'motor_form_machine_output_unit_placeholder': {
        'en': 'Select a unit',
        'fr': 'Sélectionner une unité'
    },
    'motor_form_machine_output_unit': {
        'en': 'Output unit',
        'fr': 'Unité de débit'
    },
    'motor_form_machine_output_unit_error_message': {
        'en': 'Select a unit',
        'fr': 'Sélectionner une unité'
    },
    'motor_form_machine_efficiency': {
        'en': 'Efficiency',
        'fr': 'Rendement'
    },
    'motor_form_machine_efficiency_error_message': {
        'en': 'The value must be between 0 et 1',
        'fr': 'La valeur doit être comprise entre 0 et 1'
    },
    'motor_form_machine_efficiency_tooltip': {
        'en': 'It must be between 0 et 1',
        'fr': 'Doit être compris entre 0 et 1'
    },
    'motor_form_machine_pnMe_computed': {
        'en': 'Nominal power of the trained machine',
        'fr': 'Puissance nominale de la machine entrainée'
    },
    'motor_form_duplicate_motor_number': {
        'en': 'Number of similar motors',
        'fr': 'Nombre de moteurs similaires'
    },
    'motor_form_working_duration': {
        'en': 'Working duration (h/year)',
        'fr': 'Durée de fonctionnement (h/an)'
    },
    'motor_form_annual_working_time_tooltip_message': {
        'en': 'The value for an entire year of work would be 8760',
        'fr': 'La valeur correspondant à une année entière serait 8760'
    },
    'motor_form_working_duration_error_message': {
        'en': 'The value must be between 0 and 8760',
        'fr': 'La valeur doit être comprise entre 0 et 8760'
    },
    'motor_form_next_button': {
        'en': 'next',
        'fr': 'suivant'
    },
    'motor_form_previous_button': {
        'en': 'back',
        'fr': 'retour'
    },
    'motor_dialog_title': {
        'en': 'Confirm',
        'fr': 'Confirmation'
    },
    'motor_dialog_text': {
        'en': 'Do you really want to delete this motor ', // for both language, motor's name + ' ?'
        'fr': 'Confirmez-vous la suppression du moteur '//   are added after this
    },
    // simulations page
    'no_simulation_found': {
        'en': 'No simulation found',
        'fr': 'Aucune simulation trouvée'
    },
    'no_factory': {
        'en': 'No data',
        'fr': 'Aucune donnée'
    },
    'simulations_status_computing': {
        'en': 'Data is being computed',
        'fr': 'Les données sont en train d\'être calculées',
    },
    'simulations_status_pending': {
        'en': 'Waiting for the server to process the data',
        'fr': 'En attente du traitement des données par le serveur',
    },
    'simulations_status_archived': {
        'en': 'Simulation is deleted',
        'fr': 'La simulation est supprimée',
    },
    'simulations_title': {
        'en': 'My simulations',
        'fr': 'Mes simulations',
    },
    'new_simulation_button': {
        'en': 'New simulation',
        'fr': 'Nouvelle simulation',
    },
    'simulations_search_bar': {
        'en': 'look for a simulation',
        'fr': 'chercher une simulation'
    },
    'new_simulation_dialog_title': {
        'en': 'New simulation',
        'fr': 'Nouvelle simulation',
    },
    'new_simulation_dialog_step_one': {
        'en': 'Choose a site',
        'fr': 'Choisissez un site',
    },
    'new_simulation_dialog_step_two': {
        'en': 'Choose a motor',
        'fr': 'Choisissez un moteur',
    },
    'new_simulation_dialog_step_two_empty': {
        'en': 'No motor available',
        'fr': 'Pas de moteur disponible',
    },
    'new_simulation_dialog_step_two_empty_button': {
        'en': 'Add a motor',
        'fr': 'Ajouter un moteur',
    },
    'new_simulation_warning_message': {
        'en': 'All the fields and file input are required',
        'fr': 'Tous les champs et sélecteur de fichier sont requis',
    },
    'new_simulation_dialog_data_title': {
        'en': 'Load exploitation data',
        'fr': 'Charger des données d\'exploitation',
    },
    'new_simulation_dialog_placeholder': {
        'en': 'Simulation\'s name',
        'fr': 'Nom de la simulation',
    },
    'new_simulation_dialog_data_text': {
        'en': 'Drop a file here or click to load',
        'fr': 'Glisser un fichier ici ou cliquer pour charger',
    },
    'new_simulation_dialog_data_info': {
        'en': 'files type supported : csv',
        'fr': 'Type de fichier supporté : csv',
    },
    'new_simulation_dialog_caliber': {
        'en': 'Select a caliber',
        'fr': 'Sélectionnez un calibre',
    },
    'new_simulation_name_error': {
        'en': 'No name given to the simulation',
        'fr': 'La simulation n\'est pas nommée',
    },
    'new_simulation_file_error': {
        'en': 'Upload a file for the simulation',
        'fr': 'Sélectionnez un fichier de données pour la simulation',
    },
    'new_simulation_caliber_error': {
        'en': 'Select a caliber for the simulation',
        'fr': 'Sélectionnez un calibre pour la simulation',
    },
    'simulation_waiting_time': {
        'en': 'Please wait for the data to be loaded',
        'fr': 'Veuillez attendre que les données soient chargées',
    },
    'simulation_title': {
        'en': 'Results',
        'fr': 'Résultats'
    },
    'simulation_warning': {
        'en': 'Some values were out of computing bond, more information is available inside the XLSX report, in its tab "Simulations Warnings". You can download the file by clicking on the calculation details button.',
        'fr': 'Des valeurs sont hors-plage de validité pour les calculs, plus d\'informations sont disponibles dans le rapport XLSX, dans l\'onglet "Simulations Warning". Le fichier est téléchargeable en cliquant sur le bouton détail des calculs.'
    },
    'simulation_warning_no_report_expert': {
        'en': 'No expert report available for the simulation',
        'fr': 'Aucun rapport expert disponible pour la simulation'
    },
    'simulation_warning_no_report_client': {
        'en': 'No client report available for the simulation',
        'fr': 'Aucun rapport client disponible pour la simulation'
    },
    'simulation_report_title': {
        'en': 'Consumption report',
        'fr': 'Bilan de consommation'
    },
    'simulation_report_audit': {
        'en': 'Audit',
        'fr': 'Audit'
    },
    'simulation_report_year': {
        'en': 'Year',
        'fr': 'Année'
    },
    'simulation_button': {
        'en': 'Calculation details',
        'fr': 'Détail des calculs'
    },
    'simulation_client_report_download': {
        'en': 'Client word synthesis',
        'fr': 'Synthèse word client'
    },
    'simulation_expert_report_download': {
        'en': 'Expert word synthesis',
        'fr': 'Synthèse word expert'
    },
    'simulation_noReport': {
        'en': 'No report available',
        'fr': 'Pas de rapport disponible'
    },
    'simulation_archive_button': {
        'en': 'Delete',
        'fr': 'Supprimer'
    },
    'simulation_archiving_title': {
        'en': 'Delete simulation',
        'fr': 'Supprimer la simulation',
    },
    'simulation_archiving_warning': {
        'en': 'Warning, this action cannot be cancelled, do you wish to continue ?',
        'fr': 'Attention cette action est irréversible, voulez vous continuer ?',
    },
    'simulation_archived': {
        'en': 'Deleted',
        'fr': 'Supprimé'
    },
    'simulation_error_modal_title': {
        'en': 'Computing stopped',
        'fr': 'Arrêt des calculs'
    },
    'simulation_alert_modal_title_single': {
        'en': 'simulation caution',
        'fr': 'mise en garde liée à la simulation'
    },
    'simulation_alert_modal_title_multiple': {
        'en': 'simulation cautions',
        'fr': 'mises en garde liées à la simulation'
    },
    'simulation_alert_modal_opening_button': {
        'en': 'Caution',
        'fr': 'Mise en garde'
    },
    'simulation_error_server': {
        'en': 'Error, contact an administrator',
        'fr': 'Erreur, contactez un administrateur'
    },
    'simulation_error_modal_opening_button': {
        'en': 'See errors',
        'fr': 'Voir les erreurs'
    },
    'simulation_dataless': {
        'en': 'No data available.',
        'fr': 'Pas de données disponibles.'
    },
    'simulation_data_computing': {
        'en': 'Data is being computed.',
        'fr': 'Les données sont en train d\'être calculée.'
    },
    'simulation_client_report_generating': {
        'en': 'Generating client report',
        'fr': 'Génération du rapport client'
    },
    'simulation_client_report_failed': {
        'en': 'Generation of the client report has failed',
        'fr': 'La génération du rapport client a échoué'
    },
    'simulation_expert_report_generating': {
        'en': 'Generating expert report',
        'fr': 'Génération du rapport expert'
    },
    'simulation_expert_report_failed': {
        'en': 'Generation of the expert report has failed',
        'fr': 'La génération du rapport expert a échoué'
    },
    'simulation_client_report_disabled': {
        'en': 'No client report available',
        'fr': 'Pas de rapport client disponible'
    },
    'simulation_expert_report_disabled': {
        'en': 'No expert report available',
        'fr': 'Pas de rapport expert disponible'
    },
    'simulation_report_success': {
        'en': 'The report has been successfully downloaded',
        'fr': 'Le rapport a été téléchargé'
    },
    'simulation_report_error': {
        'en': 'There was an error while retrieving the report',
        'fr': 'Une erreur s\'est produite lors de la récupération de ce rapport'
    },
    'simulation_check_button': {
        'en': 'check',
        'fr': 'voir',
    },
    'simulation_cancel_archive_button': {
        'en': 'Restore',
        'fr': 'Restaurer',
    },
    'simulation_chart_button': {
        'en': 'view chart',
        'fr': 'voir le graphique',
    },
    'simulation_chart_dialog_title': {
        'en': 'Audited motor ',
        'fr': 'Moteur audité'
    },
    'simulation_chart_title': {
        'en': 'Charging curve',
        'fr': 'Courbe de charge'
    },
    'simulation_chart_current_engine': {
        'en': 'Current motor',
        'fr': 'Moteur actuel'
    },
    'simulation_chart_pie_title': {
        'en': 'Annual consumption gain',
        'fr': 'Gain de consommation annuel'
    },
    'no_simulation_usable': {
        'en': 'No motors have a correct ROI (between 0 and 20 years) on this simulation.',
        'fr': 'Aucun moteur ne possède de TRI correct (compris entre 0 et 20 ans) sur cette simulation.'
    },
    'simulation_table_information': {
        'en': 'This table only shows the motors having a ROI between 0 and 20 years.',
        'fr': 'Le tableau ci-dessous n\'indique que les moteurs ayant un TRI compris entre 0 et 20 ans.'
    },
    'simulation_tab_solution': {
        'en': 'Energy efficiency solution',
        'fr': 'Solution d\'éfficacité énergétique'
    },
    'simulation_tab_gain_energy': {
        'en': 'Annual energy gain',
        'fr': 'Gain énergétique annuel'
    },
    'simulation_tab_gain_percent': {
        'en': 'Gain',
        'fr': 'Gain'
    },
    'simulation_tab_gain_money': {
        'en': 'Annual economic payoff',
        'fr': 'Gain économique annuel'
    },
    'simulation_tab_cost': {
        'en': 'Material solution + installation cost',
        'fr': 'Coût solution matériel + installation'
    },
    'simulation_tab_ROI': {
        'en': 'ROI',
        'fr': 'TRI'
    },
    'simulation_tab_inclusion': {
        'en': 'Include in the report',
        'fr': 'Inclure dans le rapport'
    },
    'simulation_tab_select': {
        'en': 'Select',
        'fr': 'Sélectionner'
    },
    'simulation_negative_roi': {
        'en': 'ROI < 0',
        'fr': 'TRI < 0'
    },
    'simulation_roi_higer_than_20': {
        'en': 'ROI > 20 years',
        'fr': 'TRI > 20 ans'
    },
    'simulation_view_data': {
        'en': 'View stats',
        'fr': 'Voir les statistiques'
    },
    'simulation_view_daily_stats': {
        'en': 'Daily report',
        'fr': 'Bilan par jour'
    },
    'simulation_time_0_2': {
        'en': '< 2% Pn',
        'fr': '< 2% Pn'
    },
    'simulation_time_2_25': {
        'en': '2 to 25% Pn',
        'fr': '2 à 25% Pn'
    },
    'simulation_time_25_50': {
        'en': '25 to 50% Pn',
        'fr': '25 à 50% Pn'
    },
    'simulation_time_50_75': {
        'en': '50 to 75% Pn',
        'fr': '50 à 75% Pn'
    },
    'simulation_time_75_100': {
        'en': '> 75% Pn',
        'fr': '> 75% Pn'
    },
    'simulation_chart_starting_number': {
        'en': 'times started (total):',
        'fr': 'nombre de démarrage (total) :'
    },
    'simulation_chart_starting_number_daily': {
        'en': 'times started (today):',
        'fr': 'nombre de démarrage (aujourd\'hui) :'
    },
    'simulation_chart_minimum_value': {
        'en': 'Minimum electric power :',
        'fr': 'Puissance électrique minimum :'
    },
    'simulation_chart_maximum_value': {
        'en': 'Maximum electric power :',
        'fr': 'Puissance électrique maximum :'
    },
    'simulation_chart_average_value_electric': {
        'en': 'Average electric power :',
        'fr': 'Puissance électrique moyenne :'
    },
    'simulation_chart_average_value': {
        'en': 'Average mechanical power :',
        'fr': 'Puissance mécanique moyenne :'
    },
    'simulation_chart_ratio': {
        'en': 'ratio (Pmax elec/Pn meca) :',
        'fr': 'ratio (Pmax elec/Pn méca) :'
    },
    'simulation_chart_number_of_start': {
        'en': 'Number of start recorded :',
        'fr': 'Nombre de démarrage :'
    },
    'simulation_chart_theoretical_efficiency': {
        'en': 'Rendement plaqué :',
        'fr': 'Theoretical efficiency :'
    },
    'simulation_chart_audit_range_label': {
        'en': 'Choose a period range',
        'fr': 'Sélectionnez une période à analyser'
    },
    'simulation_chart_audit_start_date': {
        'en': 'Start date',
        'fr': 'Date de départ'
    },
    'simulation_chart_audit_end_date': {
        'en': 'End date',
        'fr': 'Date de fin'
    },
    'simulation_chart_audit_range_separator': {
        'en': 'To',
        'fr': 'À'
    },
    'simulation_audit_stats_title': {
        'en': 'Audit stats',
        'fr': 'Statistiques de l\'audit'
    },
    'simulation_audit_ordinate': {
        'en': 'Active power (kW)',
        'fr': 'Puissance active (kW)'
    },
    'simulation_checkbox_stat': {
        'en': 'Show stats',
        'fr': 'Afficher les statistiques'
    },
    'simulation_checkbox_pa': {
        'en': 'Show active power (it might take a few seconds)',
        'fr': 'Afficher la puissance active (cela peut prendre quelques secondes)'
    },
    'simulation_audit_average_day': {
        'en': 'day\'s average value',
        'fr': 'valeur moyenne journalière'
    },
    'simulation_audit_extreme_min': {
        'en': 'extreme minimum',
        'fr': 'minimum extrême'
    },
    'simulation_audit_extreme_max': {
        'en': 'extreme maximum',
        'fr': 'maximum extrême'
    },
    'simulation_audit_average': {
        'en': 'motor\'s average value',
        'fr': 'valeur moyenne du moteur'
    },
    'simulation_audit_lower_envelop': {
        'en': 'lower envelop',
        'fr': 'enveloppe inférieure'
    },
    'simulation_audit_higher_envelop': {
        'en': 'higher envelop',
        'fr': 'enveloppe supérieure'
    },
    'simulation_audit_raw_data': {
        'en': 'raw data',
        'fr': 'données brutes'
    },
    'simulation_audit_filtered_data': {
        'en': 'filtered data',
        'fr': 'données filtrées'
    },
    'simulation_error_NaN_Inf': {
        'en': 'No valid data available, the simulation got infinites and/or complexes numbers as results ',
        'fr': 'Pas de données valides disponibles, la simulation a obtenu des nombres complexes et/ou infinis dans les résultats'
    },
    'simulation_overrides_select_motor': {
        'en': 'Select a solution',
        'fr': 'Sélectionner une solution'
    },
    'simulation_overrides_solution_cost': {
        'en': 'Motor cost (€)',
        'fr': 'Prix du moteur (€)'
    },
    'simulation_overrides_variator_cost': {
        'en': 'Variator cost (€)',
        'fr': 'Coût du variateur (€)'
    },
    'simulation_overrides_setup_cost': {
        'en': 'Installation cost (€)',
        'fr': 'Coût d\'installation (€)'
    },
    'simulation_overrides_motor_efficiency': {
        'en': 'Motor efficiency (between 0 and 1)',
        'fr': 'Rendement du moteur (entre 0 et 1)'
    },
    'simulation_overrides_variator_efficiency': {
        'en': 'Variator efficiency (between 0 and 1)',
        'fr': 'Rendement du variateur (entre 0 et 1)'
    },
    'simulation_restart': {
        'en': 'Restart simulation',
        'fr': 'Relancer la simulation'
    },
    'simulation_override_success': {
        'en': 'Override was successful, restarting the simulation',
        'fr': 'Les paramètres ont bien été mis à jour, la simulation va redémarrer'
    },
    'simulation_override_failed': {
        'en': 'Override failed',
        'fr': 'La modification des paramètres a échoué'
    },
    'simulation_override_title': {
        'en': 'Override simulation\'s parameter',
        'fr': 'Modifier les paramètres de la simulation'
    },
    'simulation_override_reset_initial_values': {
        'en': 'Return to initial values',
        'fr': 'Revenir aux valeurs initiales'
    },
    'simulation_override_reset_initial_values_ie2': {
        'en': 'Return to initial values ​​of IE2 motor',
        'fr': 'Revenir aux valeurs initiales du moteur IE2'
    },
    'simulation_override_reset_initial_values_ie3': {
        'en': 'Return to initial values ​​of IE3 motor',
        'fr': 'Revenir aux valeurs initiales du moteur IE3'
    },
    'simulation_override_reset_initial_values_ie4': {
        'en': 'Return to initial values ​​of IE4 motor',
        'fr': 'Revenir aux valeurs initiales du moteur IE4'
    },
    'simulation_override_reset_initial_values_msap': {
        'en': 'Return to initial values ​​of MSAP motor',
        'fr': 'Revenir aux valeurs initiales du moteur MSAP'
    },
    'simulation_override_reset_initial_values_current': {
        'en': 'Return to current motor initial values',
        'fr': 'Revenir aux valeurs initiales du moteur actuel'
    },
    'simulation_override_current_label': {
        'en': 'Current',
        'fr': 'Actuel'
    },
    'simulation_daily_chart_energy_title': {
        'en': 'Electric consumption (MWh)',
        'fr': 'Consommation électrique (MWh)'
    },
    'simulation_daily_chart_time_sharing_title': {
        'en': 'Time allocated by operating mode (%)',
        'fr': 'Répartition du temps par mode de fonctionnement (%)'
    },
    'simulation_daily_chart_time_sharing_legend_stop': {
        'en': 'Stopped',
        'fr': 'À l\'arrêt'
    },
    'simulation_daily_chart_time_sharing_legend_empty': {
        'en': 'Idle',
        'fr': 'À vide'
    },
    'simulation_daily_chart_time_sharing_legend_working': {
        'en': 'Working',
        'fr': 'En marche'
    },
    'simulation_daily_chart_economic_title': {
        'en': 'Economic consumption (€)',
        'fr': 'Consommation économique (€)'
    },
    'simulation_daily_chart_stats': {
        'en': 'Daily stats (kW)',
        'fr': 'Statistiques journalières (kW)'
    },
    'simulation_daily_chart_legends_pmax_extreme': {
        'en': 'Extreme Pmax',
        'fr': 'Pmax extrême'
    },
    'simulation_daily_chart_legends_pmax': {
        'en': 'Running Pmax',
        'fr': 'Pmax en fonctionnement'
    },
    'simulation_daily_chart_legends_average': {
        'en': 'Average',
        'fr': 'Moyenne'
    },
    'simulation_daily_chart_legends_pmin': {
        'en': 'Running Pmin',
        'fr': 'Pmin en fonctionnement'
    },
    'simulation_daily_chart_legends_pmin_extreme': {
        'en': 'Extreme Pmin',
        'fr': 'Pmin extrême'
    },
    // download page
    'download_title': {
        'en': 'Report',
        'fr': 'Rapport'
    },
    'download_button': {
        'en': 'Download the report',
        'fr': 'Télécharger le rapport'
    },
    // global buttons
    'cancel_button': {
        'en': 'cancel',
        'fr': 'annuler'
    },
    'previous_button': {
        'en': 'back',
        'fr': 'retour'
    },
    'close_button': {
        'en': 'Close',
        'fr': 'Fermer'
    },
    'return_button': {
        'en': 'Back',
        'fr': 'Retour'
    },
    'save_button': {
        'en': 'Save',
        'fr': 'Enregistrer'
    },
    'select_button': {
        'en': 'Select',
        'fr': 'Sélectionner'
    },
    'selected_button': {
        'en': 'Selected',
        'fr': 'Sélectionné'
    },
    'dialog_confirm_archive_button': {
        'en': 'Delete',
        'fr': 'Supprimer'
    },
    'notify_success_title': {
        'en': 'Success',
        'fr': 'Opération réussie'
    },
    'notify_failed_title': {
        'en': 'Operation failed',
        'fr': 'L\'opération a échoué'
    },
    'notify_site_update_successful': {
        'en': 'The audit has been successfully updated',
        'fr': 'L\'audit a bien été mis à jour'
    },
    'notify_site_create_successful': {
        'en': 'The audit has been successfully created',
        'fr': 'L\'audit a bien été créé'
    },
    'notify_site_delete_successful': {
        'en': 'The audit has been successfully deleted',
        'fr': 'L\'audit a bien été supprimé'
    },
    'notify_site_delete_failed': {
        'en': 'The audit couldn\'t be deleted',
        'fr': 'L\'audit n\'a pas pu être supprimé'
    },
    'notify_engine_update_successful': {
        'en': 'The motor has been successfully updated',
        'fr': 'Le moteur a bien été mis à jour'
    },
    'notify_engine_create_successful': {
        'en': 'The motor has been successfully created',
        'fr': 'Le moteur a bien été créé'
    },
    'notify_engine_delete_successful': {
        'en': 'The motor has been successfully deleted',
        'fr': 'Le moteur a bien été supprimé'
    },
    'notify_engine_delete_failed': {
        'en': 'The motor couldn\'t be deleted',
        'fr': 'Le moteur n\'a pas pu être supprimé'
    },
    'notify_simulation_successful': {
        'en': 'The simulation has been successfully created',
        'fr': 'La simulation a bien été créée'
    },
    'notify_simulation_data_error': {
        'en': 'There is an error is this file format, please try again',
        'fr': 'Il y a une erreur dans le formattage de ce fichier, veuillez réessayer'
    },
    'notify_simulation_archive_successful': {
        'en': 'The simulation has been successfully deleted',
        'fr': 'La simulation a bien été supprimée'
    },
    'notify_simulation_cancel_archive_successful': {
        'en': 'The simulation has been successfully restored',
        'fr': 'La simulation a bien été restaurée'
    },
    'global_user_information_latency': {
        'en': 'This action may take some time.',
        'fr': 'Cette opération peut prendre du temps.'
    },
    'client_report': {
        'en': 'client_report',
        'fr': 'rapport_client'
    },
    'expert_report': {
        'en': 'expert_report',
        'fr': 'rapport_expert'
    },
    'audit_report_pdf_generation_loading_page_message': {
        'en': 'Loading page',
        'fr': 'Page en cours de chargement'
    },
    'audit_report_pdf_generation_no_editable_fields_available': {
        'en': 'No editable fields available',
        'fr': 'Aucun champ n’est éditable'
    },
    'audit_report_pdf_generation_hide_page': {
        'en': 'Hide page',
        'fr': 'Désactiver la page'
    },
    'audit_report_pdf_generation_show_page': {
        'en': 'Show page',
        'fr': 'Activer la page'
    },
    'audit_report_pdf_generation_add_page': {
        'en': 'Add page',
        'fr': 'Ajouter une page'
    },

    'audit_report_pdf_preparation_loading_message': {
        'en': 'Report is being prepared',
        'fr': 'Préparation du rapport en cours'
    },
    'audit_report_pdf_preparation_success_message': {
        'en': 'Report has successfully been prepared!',
        'fr': 'Le rapport est prêt!'
    },
    'audit_report_pdf_preparation_error_message': {
        'en': 'Error while preparing the report',
        'fr': 'Erreur lors de la préparation du rapport'
    },
    'audit_report_pdf_generation_loading_message': {
        'en': 'Report is being computed',
        'fr': 'Génération du rapport en cours'
    },
    'audit_report_pdf_generation_success_message': {
        'en': 'Report has successfully been generated!',
        'fr': 'Le rapport a été généré avec succès!'
    },
    'audit_report_pdf_generation_error_message': {
        'en': 'Error while generating the report',
        'fr': 'Erreur lors de la génération du rapport'
    },
}



// WEBPACK FOOTER //
// ./src/lang.js